
import { Component, Vue } from "vue-property-decorator";
import Util from "@/lib/util";
import Pagination from "@/components/Pagination/index.vue";

import { RoleDto } from "@/api/service-proxies";
import { roleService } from "@/api/settings/role";

import PagedListBase, {
  PagedRequestDto
} from "@/lib/view-base/paged-list-base";

class RolePagedRequest extends PagedRequestDto {
  name!: string;
  displayName!: string;
}

@Component({
  name: "Role",
  components: {
    Pagination
  }
})
export default class Role extends PagedListBase<RolePagedRequest, RoleDto> {
  request = new RolePagedRequest();

  created() {
    this.refresh();
  }

  getpage(finishCallback: Function): void {
    roleService
      .getAll(
        this.request.name,
        this.request.displayName,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then(result => {
        this.list = result.items;
        this.showPaging(result);
      })
      .finally(() => {
        finishCallback();
      });
  }
  handleCreate() {
    this.$router.push({ path: "/sys/role/create" });
  }
  handleUpdate(role: RoleDto) {
    this.$router.push({ path: `/sys/role/update/${role.id}` });
  }
  handleDelete(role: RoleDto) {
    this.$confirm("确定删除角色?")
      .then(async () => {
        await roleService.delete(role.id);
        this.$notify.success("删除成功");
        this.refresh();
      })
      .catch(() => {});
  }
}
